import { Navigate, Outlet, useLocation } from 'react-router';

import { useAuthStore } from '@/stores/authStore';

interface Props {
  requiredStatus?: 'AUTHENTICATED' | 'UNAUTHENTICATED';
  redirectTo: string;
}

export const ProtectedRoute = ({ requiredStatus = 'AUTHENTICATED', redirectTo }: Props) => {
  const { status } = useAuthStore();
  const location = useLocation();

  if (status !== requiredStatus) {
    return <Navigate to={redirectTo} state={{ redirectTo: location }} replace />;
  }

  return <Outlet />;
};
